import { Mail, MapPin, ExternalLink } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function Reclami() {
  return (
    <div data-testid="page-reclami" className="pt-28 pb-32">
      <section className="container-x py-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="overline">Tutela del cliente</span>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl sm:text-6xl leading-[1.05] tracking-tight">
            Segnala un <span className="italic text-primary">reclamo</span>
          </h1>
          <p className="mt-4 text-primary font-medium">Reclami e sistemi di risoluzione delle controversie</p>
        </div>
      </section>

      <section className="container-x grid md:grid-cols-12 gap-16">
        <div className="md:col-span-8 md:col-start-3 space-y-16 text-muted-foreground leading-relaxed">
          <div className="space-y-6 text-lg">
            <p>
              I clienti non soddisfatti del servizio ricevuto possono comunicarci i loro reclami riguardanti il rapporto
              contrattuale o la gestione dei sinistri scrivendo a{" "}
              <a href="mailto:reclami@xlbrokers.it" className="text-foreground underline-link font-medium" data-testid="reclami-email">
                reclami@xlbrokers.it
              </a>{" "}
              e avendo cura di indicare:
            </p>
            <ul className="space-y-2 pl-6 list-disc">
              <li>nome, cognome, indirizzo completo e recapito telefonico del reclamante;</li>
              <li>numero della polizza e nominativo del contraente;</li>
              <li>eventuale numero e data del sinistro al quale si fa riferimento;</li>
              <li>eventuale indicazione del soggetto o dei soggetti di cui si lamenta l'operato;</li>
              <li>breve descrizione del motivo di lamentela;</li>
              <li>ogni ulteriore informazione o documento utile per descrivere le circostanze.</li>
            </ul>
            <p>In alternativa all'uso dell'e-mail è possibile inviare una comunicazione scritta a:</p>
            <div className="border border-foreground/10 p-6 sm:p-8 not-italic">
              <p className="font-display text-2xl text-foreground">{COMPANY.legalName}</p>
              <p className="mt-2 inline-flex items-start gap-2 text-foreground/80">
                <MapPin className="h-4 w-4 mt-1 shrink-0" />
                Via di Corticella 184/10 — 40128 Bologna (BO)
              </p>
            </div>
            <p>
              La Società prenderà in carico il reclamo e fornirà al Cliente una risposta completa{" "}
              <strong className="text-foreground">entro 15 giorni</strong> dalla data di ricezione.
            </p>
          </div>

          <div className="border-t border-foreground/10 pt-12">
            <h2 className="font-display text-3xl sm:text-4xl text-foreground">Reclami all'IVASS</h2>
            <div className="mt-6 space-y-6 text-lg">
              <p>
                Qualora il cliente non si ritenga soddisfatto dell'esito del reclamo, oppure non riceva riscontro entro
                il termine massimo di 15 giorni, potrà rivolgersi all'IVASS – Istituto per la Vigilanza sulle
                Assicurazioni – Servizio Tutela del Consumatore, Via del Quirinale 21, 00187 Roma
                <br />
                <span className="text-sm">(fax: 06 42133745 – 06 42133353).</span>
              </p>
              <p>Nel reclamo all'IVASS occorre indicare:</p>
              <ul className="space-y-2 pl-6 list-disc">
                <li>nome, cognome e indirizzo del reclamante, con eventuale recapito telefonico;</li>
                <li>indicazione del soggetto o dei soggetti di cui si lamenta l'operato;</li>
                <li>breve descrizione del motivo di lamentela;</li>
                <li>copia del reclamo già presentato a XL Brokers e dell'eventuale riscontro ricevuto;</li>
                <li>ogni documento utile a descrivere le circostanze.</li>
              </ul>
              <p>
                Eventuali reclami non relativi al rapporto contrattuale o alla gestione dei sinistri, ma riguardanti
                altre disposizioni del Codice delle Assicurazioni Private, delle norme di attuazione o delle norme sulla
                commercializzazione a distanza dei prodotti assicurativi, possono essere presentati direttamente
                all'IVASS secondo le modalità sopra indicate.
              </p>
            </div>
          </div>

          <div className="border-t border-foreground/10 pt-12">
            <h2 className="font-display text-3xl sm:text-4xl text-foreground">Ricorso all'Arbitro Assicurativo</h2>
            <div className="mt-6 space-y-6 text-lg">
              <p>
                In alternativa al ricorso all'Autorità Giudiziaria, e fermo restando l'obbligo di aver previamente
                inoltrato un reclamo a XL Brokers, il cliente ha la facoltà di presentare ricorso all'Arbitro
                Assicurativo, il sistema di risoluzione stragiudiziale delle controversie in materia assicurativa
                istituito presso l'IVASS e disciplinato dal DM 6 novembre 2024 n. 215.
              </p>
              <p className="text-foreground">L'Arbitro Assicurativo sarà operativo dal 15 gennaio 2026.</p>
              <p>
                Il ricorso potrà essere presentato esclusivamente online attraverso il sito ufficiale, dove sono
                disponibili informazioni aggiornate su competenze, modalità di accesso, modulistica e tempistiche:
              </p>
              <a href="https://www.arbitroassicurativo.it" target="_blank" rel="noreferrer"
                 className="inline-flex items-center gap-2 text-primary font-medium underline-link" data-testid="arbitro-link">
                www.arbitroassicurativo.it <ExternalLink className="h-4 w-4" />
              </a>
              <p>
                Il cliente potrà rivolgersi all'Arbitro per controversie relative ai contratti di assicurazione, incluse
                quelle inerenti l'operato dell'intermediario nelle fasi di distribuzione o gestione del rapporto.
              </p>
            </div>
          </div>

          <div className="border-t border-foreground/10 pt-12">
            <h2 className="font-display text-3xl sm:text-4xl text-foreground">Altri sistemi ADR</h2>
            <div className="mt-6 space-y-6 text-lg">
              <p>
                Resta ferma la possibilità per il cliente di avvalersi degli ulteriori sistemi di risoluzione
                stragiudiziale delle controversie previsti dalla normativa vigente, tra cui la rete FIN-NET per le
                controversie transfrontaliere all'interno dell'Unione Europea.
              </p>
              <a href="https://commission.europa.eu/fin-net_it" target="_blank" rel="noreferrer"
                 className="inline-flex items-center gap-2 text-primary font-medium underline-link" data-testid="finnet-link">
                commission.europa.eu/fin-net_it <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="border-t border-foreground/10 pt-10 flex flex-wrap gap-4">
            <a href="mailto:reclami@xlbrokers.it" data-testid="reclami-cta-email" className="btn-primary">
              <Mail className="h-4 w-4" /> Invia un reclamo via email
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
